import React from 'react'

import { Box, Text, theme } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import { Cross } from '@factorialco/factorial-one-react/icons/app'
import { InAppCommsModal, Maybe } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CommsButton from '../CommsButton'
import Media from '../Media'

interface AnnouncementModalProps {
  content: Maybe<InAppCommsModal> | undefined
  componentName: string
  onDismiss: () => void
}

const AnnouncementModal = ({ content, componentName, onDismiss }: AnnouncementModalProps) => {
  const handleClose = (e?: React.MouseEvent) => {
    e?.stopPropagation()
    onDismiss()
    track(trackingEvents.inAppComms.dismissInAppCommsComponent, {
      component: 'in_app_comms_modal',
      componentName,
    })
  }

  useEffect(() => {
    if (!content?.title) return
    track(trackingEvents.inAppComms.viewInAppCommsComponent, {
      component: 'in_app_comms_modal',
      componentName,
    })
  }, [content?.title, componentName])

  if (!content) return null

  return (
    <Box
      width="full"
      height="full"
      justifyContent="center"
      alignItems="center"
      style={{
        background: 'rgba(0,0,0,0.3)',
        zIndex: theme.zIndex.modals,
        position: 'fixed',
      }}
    >
      <Box
        background="grey000White"
        borderRadius={{ all: 'abs016' }}
        width="s600"
        position="relative"
        style={{
          overflow: 'auto',
          maxHeight: '90vh',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          position="absolute"
          style={{
            top: '8px',
            right: '8px',
            zIndex: theme.zIndex.modals + 2,
          }}
        >
          <Button
            onClick={handleClose}
            variant="outline"
            size="md"
            icon={Cross}
            hideLabel
            round
            label="Close"
          />
        </Box>
        <Media content={content} />
        <Box padding="s16" paddingBottom="s24" gap="s24" alignItems="center">
          <Box gap="s8" alignItems="center" style={{ maxWidth: '90%', textAlign: 'center' }}>
            <Text.Header2 weight="semibold" ellipsis lineClamp={2}>
              {content.title}
            </Text.Header2>
            <Text.Normal size="300" ellipsis lineClamp={3}>
              {content.description}
            </Text.Normal>
          </Box>
          <Box flexDirection="row" gap="s16">
            {content.buttons.map((button, index) => (
              <CommsButton
                key={index}
                button={button}
                size="md"
                variant={
                  content.buttons.length === 1 ? 'default' : index === 0 ? 'outline' : 'default'
                }
                componentType="in_app_comms_modal"
                componentName={componentName}
                onClick={() => onDismiss()}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AnnouncementModal
